export default __webpack_public_path__ + "images/maps-marker.51178048d747de61fd1b4754e1dfcf0d.png";